import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tag14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.99994 6C9.55222 6 9.99994 5.55228 9.99994 5C9.99994 4.44772 9.55222 4 8.99994 4C8.44765 4 7.99994 4.44772 7.99994 5C7.99994 5.55228 8.44765 6 8.99994 6Z'
      fill='currentColor'
    />
    <path
      d='M6.4696 9.53033L4.4696 7.53033L5.53026 6.46967L7.53026 8.46967L6.4696 9.53033Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.20703 1.25C6.87551 1.25 6.55757 1.3817 6.32315 1.61612L0.823148 7.11612C0.334993 7.60427 0.334991 8.39573 0.823148 8.88388L5.11604 13.1768C5.6042 13.6649 6.39565 13.6649 6.88381 13.1768L12.3838 7.67678C12.6182 7.44236 12.7499 7.12441 12.7499 6.79289V2.5C12.7499 1.80964 12.1903 1.25 11.4999 1.25H7.20703ZM2.06058 8L7.31058 2.75H11.2499V6.68934L5.99992 11.9393L2.06058 8Z'
      fill='currentColor'
    />
  </Svg>
);

Tag14.displayName = 'Tag14';
export default Tag14;
